import Amplify from 'aws-amplify' // API, // Auth,

Amplify.Logger.LOG_LEVEL = process.env.VUE_APP_AMPLIFY_LOG_LEVEL
Amplify.configure({
  Auth: {
    region: process.env.VUE_APP_AWS_REGION,
    // identityPoolId: process.env.VUE_APP_AWS_COGNITO_ID_POOL_ID,
    userPoolId: process.env.VUE_APP_AWS_COGNITO_USERPOOL_ID,
    userPoolWebClientId: process.env.VUE_APP_AWS_COGNITO_USERPOOL_CLIENT_ID,
  },
  // API: {
  //   endpoints: [{
  //     name: process.env.VUE_APP_API_NAME,
  //     endpoint: process.env.VUE_APP_API_ENDPOINT,
  //     region: process.env.VUE_APP_AWS_REGION,
  //   }]
  // },
})
